<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	{{#if newUser}}
	<h4 class="modal-title">{{TR "Neuer Administrator"}}</h4>
	{{else}}
	<h4 class="modal-title">{{TR "Rechte Anpassen"}}</h4>
	{{/if}}
</div>

<div class="modal-body">
	{{#if newUser}}
		<div id="js-email-region"></div>
	{{/if}}
	<div class="row p-b-10">
		{{#each permissions}}
			<div class="row">
				<div class="col-xs-5">
					<p class="form-control-static pull-right">{{TR this.title}}</p>
				</div>
				<div class="col-xs-7">
					<div id="{{this.id}}" class="button-list pull-left {{#if disabled}}disabled{{/if}}">
						<div class="js-enabled js-perm-set btn btn-{{#if this.permission}}inverse{{else}}white{{/if}}">
							<i class="fa fa-check"></i>
						</div>
						<div class="js-disable js-perm-set btn btn-{{#if this.permission}}white{{else}}inverse{{/if}}">
							<i class="fa fa-minus"></i>
						</div>
					</div>
				</div>
			</div>
		{{/each}}
	</div>
	<div class="row">
		<div class="col-xs-5">
			<p class="form-control-static pull-right">{{TR "Gerätezugriff"}}</p>
		</div>
			<div class="col-xs-7">
			{{#SELECT selectedPermission}}
				<select id="js-device-permission" class="selectpicker" data-style="btn-{{selected}}">
					{{#each devicePermissions}}
						<option value="{{value}}">{{TR name}}</option>
					{{/each}}
				</select>
			{{/SELECT}}
		</div>
	</div>
</div>

<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">
		{{TR "Abbrechen"}}
	</button>
	<button class="btn btn-primary" id="js-save" {{#unless hasAnyPermission}}disabled{{/unless}}>
		{{TR "Speichern"}}
	</button>
</div>
